import React, { Component } from "react";
import "./index.scss";
import DefaultLayout from "layouts/Default";
import { Typography } from "@material-ui/core";

export default class TermsAndConditionsPage extends Component {

  render() {
    return (
      <DefaultLayout id="terms-conditions-page">
        <Typography variant="h1" component="h1">
          WEBSITE TERMS AND CONDITIONS OF USE
        </Typography>
        <Typography variant="body1">
          Effective as of 15th October 2021
        </Typography>
        <ol start={1}>
          <li>
            <Typography variant="h3" component="h3">
              INTRODUCTION
            </Typography>
            <Typography variant="body1">
              Thank you for using Sook Retail Ltd. These terms and conditions
              apply between you, the User of this Website (including any
              sub-domains, unless expressly excluded by their own terms and
              conditions), and Sook Retail Ltd, the owner and operator of this
              Website. Please read these terms and conditions carefully, as they
              affect your legal rights. Your agreement to comply with and be
              bound by these terms and conditions is deemed to occur upon your
              first use of the Website. If you do not agree to be bound by these
              terms and conditions, you should stop using the Website
              immediately.
            </Typography>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              DEFINITIONS AND INTERPRETATION
            </Typography>
            <ol>
              <li>
                <Typography variant="body1">
                  In these terms and conditions, unless the context dictates
                  otherwise, the following expressions are to be understood as
                  meaning:
                </Typography>
                <table>
                  <colgroup>
                    <col width="200" />
                    <col />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>&ldquo;Account&rdquo;</th>
                      <td>
                        Means an account required for a User to access certain
                        areas of the Website, as detailed in Clause 4.
                      </td>
                    </tr>
                    <tr>
                      <th>&ldquo;The Company&rdquo;</th>
                      <td>
                        Refers to the independent legal personality of Sook
                        Retail Ltd.
                      </td>
                    </tr>
                    <tr>
                      <th>&ldquo;Content&rdquo;</th>
                      <td>
                        Means any text, graphics, images, audio, video,
                        software, data compilations, page layout, underlying
                        code and software and any other form of information
                        capable of being stored in a computer that appears on or
                        forms part of this Website.
                      </td>
                    </tr>
                    <tr>
                      <th>&ldquo;User/Users&rdquo;</th>
                      <td>
                        Means any third party that accesses the Website and is
                        not either employed by Sook Retail Ltd and acting in the
                        course of their employment; or engaged as a consultant
                        or otherwise providing services to Sook Retail Ltd and
                        accessing the Website in connection with the provision
                        of such services.
                      </td>
                    </tr>
                    <tr>
                      <th>&ldquo;User Content&rdquo;</th>
                      <td>
                        Means any content submitted to our Website by Users, as
                        detailed in Clause 7.
                      </td>
                    </tr>
                    <tr>
                      <th>&ldquo;We/Us/Our&rdquo;</th>
                      <td>
                        Means Sook Retail Ltd. A Company incorporated in England
                        and Wales with registered number 11912445, whose
                        registered address is 61- 65 Church Street, Harston,
                        Cambridgeshire, CB22 7NP, and operates the website
                        www.sook.space.
                      </td>
                    </tr>
                    <tr>
                      <th>&ldquo;Website/Site&rdquo;</th>
                      <td>
                        The web domain{" "}
                        <a href="https://www.google.com/url?q=http://www.sook.space&amp;sa=D&amp;source=editors&amp;ust=1636674789608000&amp;usg=AOvVaw2rMiKvgmsmv-Z4vRlt8VB1">
                          www.sook.space
                        </a>
                        , and any other sub-domains, unless expressly excluded
                        by their own terms and conditions.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </li>
            </ol>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              ACCESS TO THE WEBSITE
            </Typography>
            <ol>
              <li>Access to the Website is free of charge.</li>
              <li>
                It is your responsibility to make any and all arrangements
                necessary to access the Website.
              </li>
              <li>
                Access to the Website is provided &ldquo;as is&rdquo; and on an
                &ldquo;as available&rdquo; basis. We may alter, suspend or
                discontinue the Website (or any part of it) at any time and
                without notice. We will not be liable to you in any way if the
                Website (or any part of it) is unavailable to you at any time
                and for any period.
              </li>
            </ol>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              REGISTRATION AND ACCOUNTS
            </Typography>
            <ol>
              <li>
                Certain parts of the Website (including the ability to purchase
                services from Us) may require an Account in order to access
                them. By registering, you will create a personalized account
                which includes a unique username and a password to access the
                Website and to receive messages from the Company.
              </li>
              <li>
                You must be at least 18 years of age to use this Website. By
                using the Website and agreeing to these terms and conditions,
                you represent and warrant that you are at least 18 years of age.
              </li>
              <li>
                You must ensure that the details provided by you on registration
                or at any time are correct and complete. You must also inform us
                of any changes to this information by updating your personal
                details to ensure that Sook Retail Ltd can communicate with you
                effectively.
              </li>
              <li>
                Sook Retail Ltd may suspend or cancel your registration with
                immediate effect for any reasonable purposes or if you breach
                these terms and conditions.
              </li>
              <li>
                You may cancel your registration at any time by informing us in
                writing to the email address: enquiries@sook.space. If you do
                so, you must immediately stop using the Website. Cancellation or
                suspension of your registration does not affect any statutory
                rights.
              </li>
              <li>
                We recommend that you choose a strong password for your Account,
                consisting of a combination of lowercase and uppercase letters,
                numbers and symbols. It is your responsibility to keep your
                password safe. You agree to notify us immediately of any
                unauthorized use of your password and/or account by emailing
                enquiries@sook.space. The Company will not be responsible for
                any liabilities, losses, or damages arising out of the
                unauthorized use of your member name, password and/or account.
              </li>
            </ol>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              PRIVACY POLICY
            </Typography>
            <ol>
              <li>
                Sook Retail Ltd respects the privacy of its users. Use of the
                Website is also governed by our Privacy Policy and Cookies
                Policy, which are incorporated into these terms and conditions
                by this reference. The Privacy Policy explains how we collect,
                use, and disclose information that pertains to your privacy, and
                can be found by following this link:{" "}
                <a href="https://www.google.com/url?q=https://www.sook.space/legal/privacy&amp;sa=D&amp;source=editors&amp;ust=1636674789613000&amp;usg=AOvVaw2-ygX4p328AXUS71YamvjE">
                  https://www.sook.space/legal/privacy
                </a>{" "}
                . The Cookies Policy details which Cookies are used by Our
                Website and Our Legal Basis for using them.
              </li>
            </ol>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              INTELLECTUAL PROPERTY RIGHTS
            </Typography>
            <ol>
              <li>
                With the exception of User Content (see Clause 7) all content
                included on the Website is the property of Sook Retail Ltd, and
                the copyright and other property rights subsisting in that
                Content, unless specifically labelled otherwise, belongs to, or
                has been licenced by Us. All Content (including User Content) is
                protected by applicable United Kingdom and International
                intellectual property laws and treaties.
              </li>
              <li>
                Nothing on this site shall be construed as granting, by
                implication, estoppel or otherwise, any licence or right to use
                any trademark, logo or service mark displayed on the site
                without the owner&rsquo;s prior written permission.
              </li>
              <li>
                Subject to Clauses 6.4 and 6.6, you may not reproduce, copy,
                distribute, sell, rent, sub-licence, store, or in any other
                manner re-se Content from Our Site unless given express written
                permission to do so by Us.
              </li>
              <li>
                You may:
                <ol>
                  <li>
                    Access, view and use the Website in a web browser (including
                    any web browsing capability built into other types of
                    software or app);
                  </li>
                  <li>
                    Save or download pages from the Website for offline viewing
                    only.
                  </li>
                </ol>
              </li>
              <li>
                Our status as the owner and author of the Content on Our Site
                (or that of identified licensors, as appropriate) must be
                acknowledged.
              </li>
              <li>
                You must not re-use any Content printed, or saved from Our Site
                for commercial purposes without first obtaining a licence from
                Us (or Our licensors as appropriate) to do so. This does not
                prohibit the normal access, viewing and use of Our Site whether
                by businesses or consumers.
              </li>
            </ol>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              USER CONTENT
            </Typography>
            <ol>
              <li>
                User Content on Our Site includes (though is not limited to) any
                text, graphics, images, audio, video, software, data
                compilations, page layout, underlying code and software and any
                other form of information capable of being stored in a computer
                that has been submitted or uploaded by Users.
              </li>
              <li>
                An Account is required in order to submit / upload User Content.
                Please refer to Clause 4 for further information.
              </li>
              <li>
                You acknowledge that you are responsible for any content you may
                submit via the Website. Specifically, you agree, represent and
                warrant that you have the right to submit the User content and
                that all such User Content will comply with Our Acceptable Use
                Policy, detailed in Clause 8 below.
              </li>
              <li>
                You agree that you will be liable to Us and will, to the fullest
                extent permissible by law, indemnify Us for any breach of the
                warranties given by you under sub-Clause 7.2. You will be
                responsible for any loss or damage suffered by Us as a result of
                such a breach.
              </li>
              <li>
                You (or your licensors, as appropriate) retain ownership of your
                User Content and all intellectual property rights subsisting
                therein. When you submit User Content you grant Us an
                unconditional, non-exclusive, fully transferable, royalty-free,
                perpetual worldwide licence to use, store, archive, syndicate,
                publish, transmit, adapt, edit, reproduce, distribute, prepare
                derivative works from, display, perform and sub-licence your
                User Content for the purposes of operating, marketing, and
                promoting Our Site and its services. This does not grant Other
                Users the right to copy and quote your User Content within Our
                Site.
              </li>
              <li>
                If you wish to remove User Content from Our Site, the User
                content in question will be anonymised by removing your username
                and any logos or trademarks. Please note, however, that caching
                or references to your User content may not be made immediately
                unavailable, or at all, if this is outside of our reasonable
                control.
              </li>
              <li>
                We may reject, reclassify, or remove any User content from Our
                Site where, in Our sole opinion, it violates Our Acceptable Use
                Policy, or if We receive a complaint from a third party and
                determine that the User content in question should be removed as
                a result.
              </li>
              <li>
                We are not responsible for the content or accuracy, or for any
                opinions, views, or values, expressed in User Content. Any such
                opinions, views or values are those of the relevant User and do
                not reflect Our opinions, views or values in any way.
              </li>
            </ol>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              ACCEPTABLE USE POLICY
            </Typography>
            <ol>
              <li>
                You may only use Our Site in a manner that is lawful and that
                complies with the provisions of this Clause 8. Specifically:
                <ol>
                  <li>
                    You must ensure that you comply fully with any and all
                    local, national or international laws and/regulations;
                  </li>
                  <li>
                    You must not use Our Site in any way, or for any purpose,
                    that is unlawful or fraudulent;
                  </li>
                  <li>
                    You must not use Our Site to knowingly send, upload, display
                    or in any other way transmit data that contains any form of
                    virus or other malware, or any other code designed to
                    adversely affect computer hardware, software, or data of any
                    kind; and
                  </li>
                  <li>
                    You must not use Our Site in any way, or for any purpose,
                    that is intended to harm any person or persons in any way.
                  </li>
                </ol>
              </li>
              <li>
                When uploading or submitting User Content (or communicating in
                any other way using Our Site), you must not communicate, display
                or otherwise do anything that:
                <ol>
                  <li>Is sexually explicit;</li>
                  <li>
                    Is obscene, deliberately offensive, hateful or otherwise
                    inflammatory;
                  </li>
                  <li>Promotes violence;</li>
                  <li>Promotes or assists in any form of unlawful activity;</li>
                  <li>
                    Discriminates against, or is in any way defamatory of any
                    person, group or class of persons, race, gender, religion,
                    nationality, disability, sexual orientation or age;
                  </li>
                  <li>
                    Is intended or otherwise likely to threaten, annoy, alarm,
                    inconvenience, upset, or embarrass another person;
                  </li>
                  <li>Is calculated or is otherwise likely to deceive;</li>
                  <li>
                    Is intended or otherwise likely to infringe (or threaten to
                    infringe) another person&rsquo;s right to privacy or
                    otherwise uses their personal data in a way that you do not
                    have the right to;
                  </li>
                  <li>
                    Misleadingly impersonates any person or otherwise
                    misrepresents your identity or affiliation in a way that is
                    calculated to deceive (obvious parodies are not included
                    within this definition provided that they do not fall within
                    any of the provisions of this sub-Clause 8.2);
                  </li>
                  <li>
                    Implies any form of affiliation with Us where none exists;
                  </li>
                  <li>
                    Infringes, or assists in the infringement of, the
                    intellectual property rights (including but not limited to,
                    copyright, patents, trademarks and database rights) of any
                    other party; or
                  </li>
                  <li>
                    Is in breach of any legal duty owed to a third party
                    including, but not limited to, contractual duties and duties
                    of confidence.
                  </li>
                </ol>
              </li>
              <li>
                We reserve the right to suspend or terminate your access to Our
                Site if you materially breach the provisions of this Clause 8,
                or any of the other provisions of these Terms and Conditions of
                Use. Specifically, We make take one or more of the following
                actions:
                <ol start={19}>
                  <li>
                    Suspend, whether temporarily or permanently your Account
                    and/or your right to access Our Site;
                  </li>
                  <li>
                    Remove any User Content uploaded by you that violates this
                    Acceptable Use Policy;
                  </li>
                  <li>
                    Issue you with a written warning, either through the Website
                    or through email.
                  </li>
                  <li>
                    Take legal proceedings against you for reimbursement of any
                    and all relevant costs on an indemnity basis resulting from
                    your breach;
                  </li>
                  <li>Take further legal action against you as appropriate;</li>
                  <li>
                    Disclose such information to law enforcement authorities as
                    required or as We deem reasonably necessary; and/or
                  </li>
                  <li>
                    Any other actions which We deem reasonably appropriate (and
                    lawful), including but not limited to cancelling a booking
                    with a possible lack of refund and/or banning the user from
                    any of the Spaces advertised by Sook.
                  </li>
                </ol>
              </li>
              <li>
                We hereby exclude any and all liability arising out of any
                actions (including but not limited to those set out above) that
                We may take in response to breaches of these Terms and
                Conditions of Use.
              </li>
            </ol>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              VIRUSES, MALWARE AND SECURITY
            </Typography>
            <ol>
              <li>
                We exercise all reasonable care and skill to ensure that Our
                Site is secure and free from viruses and other malware.
              </li>
              <li>
                You are responsible for protecting your hardware, software, data
                and other material from viruses, malware and any other internet
                security risks.
              </li>
              <li>
                You must not deliberately introduce viruses or other malware, or
                any other material which is malicious or technologically harmful
                either to or via Our Site.
              </li>
              <li>
                You must not attempt to gain unauthorised access to any part of
                Our Site, the server on which Our Site is stored, or any other
                server, computer, or database connected to Our Site.
              </li>
              <li>
                You must not attack Our Site by means of a denial of service
                attack, a distributed denial of service attack, or by any other
                means.
              </li>
              <li>
                You must not bypass any robot exclusion headers or other
                measures we take to restrict access to the Website, or use any
                software, technology, or device to scrape, spider, or crawl the
                Website or harvest or manipulate data; circumvent, disable or
                otherwise interfere with any security-related features of the
                Website or features that prevent or restrict use or copying of
                content, or enforce limitations on use of the Website or the
                content accessible via the Website; or publish or link to
                malicious content of any sort, including that intended to damage
                or disrupt another user&rsquo;s browser or computer.
              </li>
              <li>
                By breaching the provisions of sub-Clauses 9.3 to 9.5, you may
                be committing a criminal offence under the Computer Misuse Act
                1990. Any and all such breaches will be reported to the relevant
                law enforcement authorities and We will cooperate fully with
                those authorities by disclosing your identity to them. Your
                right to use Our Site will cease immediately in the event of
                such a breach.
              </li>
            </ol>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              LINKS TO OUR SITE
            </Typography>
            <ol>
              <li>
                You may not link to any page other than the homepage of Our
                Site:{" "}
                <a href="https://www.google.com/url?q=https://www.sook.space/&amp;sa=D&amp;source=editors&amp;ust=1636674789625000&amp;usg=AOvVaw0Br6MTJ0fHH0BzIu37Z4XE">
                  https://www.sook.space/
                </a>{" "}
                . Deep Linking to other pages requires Our express written
                permission. Please contact us at enquiries@sook.space for
                further information.
              </li>
              <li>
                Framing or embedding of Our Site on other websites is not
                permitted without Our express written permission.
              </li>
              <li>
                You may not link to our site from any other site the main
                content of which contains materials that breach the conditions
                outlined in the Acceptable Use Policy detailed in sub-Clause
                8.2.
              </li>
              <li>
                The content restrictions in sub-Clause 10.3 do not apply to
                content submitted to sites by other users provided that the
                primary purpose of the site accords with the provisions of
                sub-Clause 10.3. You are not, for example, prohibited from
                posting links on general purpose social networking sites merely
                because another user may post such content. You are, however,
                prohibited from posting links on websites which focus on or
                encourage the submission of such content from users.
              </li>
            </ol>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              LINKS TO OTHER WEBSITES AND/OR MATERIALS
            </Typography>
            <ol>
              <li>
                The Website may contain links to third party website(s)
                (&ldquo;Third Party Sites&rdquo;) as well as content or items
                belonging to or originating from third parties (the &ldquo;Third
                Party Applications, Software or Content&rdquo;). Unless
                expressly stated, We have no control over Third Party Sites or
                Third Party Applications, Software or Content or the promotions,
                materials, information, goods or services available on these
                Third Party Sites or Third Party Applications, Software or
                Content.
              </li>
              <li>
                Such Third Party Sites and Third Party Applications, Software or
                Content are not investigated, monitored or checked for accuracy,
                appropriateness, or completeness, and we are not responsible for
                any Third Party Sites accessed through the Site or any Third
                Party Applications, Software or Content posted on, available
                through or installed from the Site, including the content,
                accuracy, offensiveness, opinions, reliability, privacy
                practices or other policies of or contained in the Third Party
                Sites or the Third Party Applications, Software or Content.
              </li>
              <li>
                Inclusion of, linking to or permitting the use or installation
                of any Third Party Site or any Third Party Applications,
                Software or Content does not imply our approval or endorsement.
              </li>
              <li>
                If you decide to leave the Site and access the Third Party Sites
                or to use or install any Third Party Applications, Software or
                Content, you do so at your own risk and you should be aware that
                our terms and policies, including these Terms of Use, no longer
                govern. You should review the applicable terms and policies,
                including privacy and data gathering practices, of any Third
                Party Site to which you navigate from the Site or relating to
                any applications you use or install from the Third Party Site.
              </li>
              <li>
                We grant the operators of public search engines permission to
                use spiders to copy materials from the site for the sole purpose
                of creating publicly-available searchable indices but retain the
                right to revoke this permission at any time on a general or
                specific basis.
              </li>
            </ol>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              LIABILITY AND DISCLAIMERS
            </Typography>
            <ol>
              <li>
                Nothing on Our Site constitutes advice on which you should rely.
                It is provided for information purposes only.
              </li>
              <li>
                Insofar as it is permitted by law, We make no representation,
                warranty or guarantee that Our Site will meet your requirements,
                that it will not infringe the rights of third parties, that it
                will be compatible with all software and hardware or that it
                will be secure.
              </li>
              <li>
                We make reasonable efforts to ensure that the Content on Our
                Site is complete, accurate, and up-to date. We do not, however,
                make any representations, warranties or guarantees (whether
                express or implied) that the Content is complete, accurate or
                up-to-date.
              </li>
              <li>
                The Website does not, and cannot, pre-screen or monitor all User
                Content. However, at our discretion, we, or technology we
                employ, may monitor and/or record your interactions with the
                Website. See privacy policy for further details:{" "}
                <a href="https://www.google.com/url?q=https://www.sook.space/legal/privacy&amp;sa=D&amp;source=editors&amp;ust=1636674789629000&amp;usg=AOvVaw3R3pKyv8QzQStxpEsGZ0RM">
                  https://www.sook.space/legal/privacy
                </a>{" "}
                .
              </li>

              <li>
                To the fullest extent permissible by law, We accept no liability
                to any User for any loss or damage, whether foreseeable or
                otherwise, in contract, tort (including negligence), for breach
                of statutory duty, or otherwise, arising out of or in connection
                with the use of (or inability to use) Our Site or the use of or
                reliance upon any Content (including User Content) included on
                Our Site.
              </li>
              <li>
                For business users, We hereby exclude all implied conditions,
                warranties, representations or other terms that may apply to Our
                Site or Content. We will not be liable for any loss of profits,
                sales, business or revenue; loss of business opportunity,
                goodwill or reputation; loss of anticipated savings; business
                interruption; loss or corruption of any data, database or
                software, or for any indirect or consequential loss or damage.
              </li>
              <li>
                If you are a consumer User, please note that the primary
                function of our Site is for business purposes. However, if as a
                result of Our failure to exercise reasonable care and skill, any
                digital content from Our site damages your device or other
                digital content belonging to you, you may be entitled to certain
                legal remedies. For more details please contact your local
                Citizens Advice Bureau or Trading Standards Office.
              </li>
              <li>
                We neither assume nor accept responsibility or liability arising
                out of any disruption or non-availability of Our Site resulting
                from external causes including, but not limited to, ISP
                equipment failure, host equipment failure, communications
                network failure, pandemics, natural events, acts of war, or
                legal restrictions and censorship.
              </li>
              <li>
                Nothing in these terms and conditions of use excludes or
                restricts Our or your liability for fraud or fraudulent
                misrepresentation, for death or personal injury resulting from
                negligence, or for any other forms of liability which cannot be
                excluded or restricted by law.
              </li>
              <li>
                The limitations of liability in this Clause 12 apply only to the
                use of Our Site and not the use of any of the Sook Retail Ltd
                physical spaces, which is governed by Our individual Occupation
                Agreement for each physical space, made available on confirming
                a booking of the space.
              </li>
            </ol>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              CHANGES TO THESE TERMS AND CONDITIONS OF USE
            </Typography>
            <ol>
              <li>
                We may alter these Terms and Conditions of Use at any time. Any
                such change will become binding upon you upon your first use of
                Our Site after the changes have been implemented. You are
                therefore advised to check this page from time to time.
              </li>
              <li>
                In the event of any conflict between the current version of
                these Terms and Conditions of Use and any previous version(s),
                the provisions current and in effect shall prevail unless it is
                expressly stated otherwise.
              </li>
            </ol>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              GENERAL TERMS
            </Typography>
            <ol>
              <li>
                If any part of this Terms of Use agreement is held or found to
                be invalid or unenforceable, that portion of the agreement will
                be construed as to be consistent with applicable law while the
                remaining portions of the agreement will remain in full force
                and effect. Any failure on our part to enforce any provision of
                this agreement will not be considered a waiver of our right to
                enforce such provision. Our rights under this agreement survive
                any transfer or termination of this agreement.
              </li>
              <li>
                You agree that any cause of action related to or arising out of
                your relationship with the Company must commence within ONE year
                of the cause of action accrues. Otherwise, such cause of action
                is permanently barred.
              </li>
              <li>
                We may assign or delegate these Terms of Service and/or our
                Privacy Policy, in whole or in part, to any person or entity at
                any time with or without your consent. You may not assign or
                delegate any rights or obligations under the Terms of Service or
                Privacy Policy without our prior written consent, and any
                unauthorized assignment or delegation by you is void.
              </li>
            </ol>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              CONTACTING US
            </Typography>
            <ol>
              <li>
                If we have your contact details, We may from time to time send
                you important notices by email. Such notices may relate to
                matters including, but not limited to, service changes, changes
                to these Terms and Conditions of Use, Our Privacy Policy and
                Occupation Agreement, and changes to your Account.
              </li>
              <li>
                We will never send you marketing emails of any kind without your
                express consent. If you do give such consent, you may opt out at
                any time by emailing enquiries@sook.space. If you opt out of
                receiving emails from us it may take up to 5 working days for Us
                to comply with your request, during this time you may still
                receive emails from Us.
              </li>
              <li>
                For questions or complaints about communications from Us
                (including, but not limited to marketing emails), please contact
                us at enquiries@sook.space, or via the chat box on our homepage:{" "}
                <a href="https://www.google.com/url?q=https://www.sook.space/&amp;sa=D&amp;source=editors&amp;ust=1636674789634000&amp;usg=AOvVaw1WlDyXnd7Im6O6VGrqiBXq">
                  https://www.sook.space/
                </a>{" "}
                .
              </li>
            </ol>
          </li>
          <li>
            <Typography variant="h3" component="h3">
              LAW AND JURISDICTION
            </Typography>
            <ol>
              <li>
                These Terms and Conditions of Use, and the relationship between
                you and Us (whether conditional or otherwise) shall be governed
                by, and construed in accordance with the Law of England and
                Wales, the Law of Scotland, and the Law of Northern Ireland.
              </li>
              <li>
                Any disputes concerning these Terms and Conditions of Use, the
                relationship between you and Us, or any matters arising
                therefrom or associated therewith (whether contractual or
                otherwise) shall be subject to the exclusive jurisdiction of the
                courts of England and Wales, and the courts of Scotland.
              </li>
            </ol>
          </li>
        </ol>
        <Typography variant="body1" className="acknowledgement">
          You acknowledge that you have read these terms and conditions of use,
          Understand the terms and conditions of use, and will be bound by these
          Terms and conditions. You further acknowledge that these terms of use
          Together with the privacy policy at [
          <a href="https://www.google.com/url?q=https://www.sook.space/legal/privacy&amp;sa=D&amp;source=editors&amp;ust=1636674789635000&amp;usg=AOvVaw2HVX9GNCRscSStZ201iD4Q">
            https://www.sook.space/legal/privacy
          </a>
          ], Represent the complete and exclusive statement of the agreement
          Between us and that it supersedes any proposal or prior agreement oral
          Or written, and any other communications between us relating to the
          Subject matter of this agreement.
        </Typography>
      </DefaultLayout>
    );
  }
}
